/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SectionPermission {
    Denied = 'Denied',
    ReadOnly = 'ReadOnly',
    FullControl = 'FullControl'
}

export function SectionPermissionFromJSON(json: any): SectionPermission {
    return SectionPermissionFromJSONTyped(json, false);
}

export function SectionPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionPermission {
    return json as SectionPermission;
}

export function SectionPermissionToJSON(value?: SectionPermission | null): any {
    return value as any;
}

